































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import skyconText from '@/utils/skyconText'
export default Vue.extend({
    props: ['address', 'longitude', 'latitude'],
    computed: {
        lngLat(): any {
            const { longitude, latitude } = this
            return { longitude, latitude }
        },
    },
    watch: {
        lngLat() {
            this.getData()
        },
    },
    data() {
        return {
            data: {},
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            const url = `/v2.5/Qu1kUDHidwJHZoNF/${this.lngLat.longitude},${this.lngLat.latitude}/realtime`
            request.get(url).then((result) => {
                // console.log(result.result.realtime)
                const realtime = result.result.realtime
                const data = {
                    tem: (realtime.temperature).toFixed(1),
                    wind: (realtime.wind.speed / 3.6).toFixed(1),
                    pre: realtime.precipitation.local.intensity.toFixed(1),
                    vis: (realtime.visibility).toFixed(1),
                    prs: (realtime.pressure / 100).toFixed(1),
                    // rhu: (realtime.humidity * 100).toFixed(0),
                    skyconText: skyconText.skyconText(realtime.skycon),
                    imgUrl: `/static/weatherIcon/${realtime.skycon}.png`,
                    updateTime: moment(result.server_time * 1000).format('YYYY/MM/DD HH时mm分更新'),
                }
                this.data = data
            }).catch((err) => {
                console.log(err)
                this.$Message.warning(err)
            })
        },
    },
})
